import { AppLayoutHeaderWrapperDesktop } from "@src/appV2/redesign/AppLayout/Desktop/Header/HeaderWrapper";
import { NavigationMenuItemsDesktop } from "./Navigation/NavigationMenuItems";
import { AppLayoutWrapperDesktop } from "@src/appV2/redesign/AppLayout/Desktop/Wrapper";
import { AppLayoutHeaderDesktop } from "./Header/AppLayoutHeader";
import { AppLayoutInnerWrapperDesktop } from "@src/appV2/redesign/AppLayout/Desktop/InnerWrapper";
import { AppLayoutPageWrapperDesktop } from "@src/appV2/redesign/AppLayout/Desktop/PageWrapper";
import { NavigationMenuItemsWrapperDesktop } from "@src/appV2/redesign/AppLayout/Desktop/Navigation/MenuItemsWrapper";
import { NavigationMenuSectionTitleDesktop } from "@src/appV2/redesign/AppLayout/Desktop/Navigation/MenuSectionTitle";
import { NavigationMenuItemDesktop } from "@src/appV2/redesign/AppLayout/Desktop/Navigation/MenuItem";
import { AllRoutes } from "../Shared/Navigation/routes/AllRoutes";

export interface AppLayoutDesktopProps {
  isAdmin: boolean;
  isWorker: boolean;
  isWorkplace: boolean;
  logoutConfirm: () => void;
  renderStartPage: () => JSX.Element | null;
}

export function AppLayoutDesktop(props: AppLayoutDesktopProps) {
  const { isAdmin, isWorker, isWorkplace, logoutConfirm, renderStartPage } = props;

  return (
    <AppLayoutWrapperDesktop>
      <AppLayoutHeaderWrapperDesktop>
        <AppLayoutHeaderDesktop />
      </AppLayoutHeaderWrapperDesktop>
      <AppLayoutInnerWrapperDesktop>
        <NavigationMenuItemsWrapperDesktop>
          <NavigationMenuItemsDesktop
            isAdmin={isAdmin}
            isWorker={isWorker}
            isWorkplace={isWorkplace}
          />
          <NavigationMenuSectionTitleDesktop>Logout</NavigationMenuSectionTitleDesktop>
          <NavigationMenuItemDesktop
            iconType="door-straight"
            isSelected={false}
            onClick={() => {
              logoutConfirm();
            }}
          >
            Logout
          </NavigationMenuItemDesktop>
        </NavigationMenuItemsWrapperDesktop>
        <AppLayoutPageWrapperDesktop>
          <AllRoutes
            isAdmin={isAdmin}
            isWorker={isWorker}
            isWorkplace={isWorkplace}
            renderStartPage={renderStartPage}
          />
        </AppLayoutPageWrapperDesktop>
      </AppLayoutInnerWrapperDesktop>
    </AppLayoutWrapperDesktop>
  );
}
